if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    connectedCallback () {
      this.max     = Number(this.dataset.count) || 6;
      this.current = this.dataset.productHandle;
      this.listEl  = this.querySelector('.products');
      this.emptyEl = this.querySelector('.recently-viewed-empty-state');

      /* ok buton referansları */
      this.prevBtn = this.querySelector('.slider-arrow-left');
      this.nextBtn = this.querySelector('.slider-arrow-right');

      this.saveToLocal();
      this.fetchCards();
    }

    saveToLocal () {
      try {
        const key   = 'recently-viewed';
        const items = JSON.parse(localStorage.getItem(key) || '[]');

        const idx = items.indexOf(this.current);
        if (idx > -1) items.splice(idx, 1);
        items.unshift(this.current);

        localStorage.setItem(key, JSON.stringify(items.slice(0, 20)));
      } catch (err) {
        console.warn('[recent] LocalStorage error →', err);
      }
    }

    async fetchCards () {
      const handles = (JSON.parse(localStorage.getItem('recently-viewed') || '[]'))
                        .filter(h => h !== this.current)
                        .slice(0, this.max);

      if (!handles.length) { this.showEmpty('Liste boş'); return; }

      const query      = handles.map(h => `handle:${h}`).join(' OR ');
      const root       = (window.Shopify?.routes?.root)       || '/';
      const searchBase = (window.Shopify?.routes?.search_url) || `${root}search`;
      const url        = `${searchBase}?view=card-product&type=product&q=${encodeURIComponent(query)}`;

      try {
        const res  = await fetch(url, { credentials: 'same-origin' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const html = await res.text();
        const tmp  = document.createElement('div'); tmp.innerHTML = html;

        const cards = tmp.querySelectorAll('.products > li');
        if (!cards.length) { this.showEmpty('Kart bulunamadı'); return; }

        cards.forEach(card => {
          card.classList.add('grid__item');
          this.listEl.appendChild(card);
        });
        this.closest('.js-recently-wrap')?.classList.remove('hidden');
        
        this.classList.add('product-recommendations--loaded');

        this.step = this.listEl.querySelector('li')?.offsetWidth || 0;
        this.initSlider();

        setTimeout(() => window.dispatchEvent(new Event('resize')), 50);
      } catch (err) {
        console.error('[recent] fetch error →', err);
        this.showEmpty('Fetch hata');
      }
    }

    initSlider () {
      if (this._sliderReady || !this.step) return;
      this._sliderReady = true;

      Object.assign(this.listEl.style, {
        overflowX:      'auto',
        scrollBehavior: 'smooth',
        scrollSnapType: 'x mandatory'
      });
      this.listEl.querySelectorAll('li').forEach(li =>
        li.style.scrollSnapAlign = 'start'
      );

      /* ok tıklamaları */
      this.prevBtn?.addEventListener('click', () => this.scrollOne(-1));
      this.nextBtn?.addEventListener('click', () => this.scrollOne( 1));

      /* okların aktif/pasif hâlini güncelle */
      this.listEl.addEventListener('scroll', () => this.updateArrows());
      window.addEventListener('resize', () => {
        this.step = this.listEl.querySelector('li')?.offsetWidth || 0;
        this.updateArrows();
      });

      this.updateArrows();
    }

    scrollOne (dir) {
      if (!this.step) return;
      this.listEl.scrollBy({ left: dir * this.step, behavior: 'smooth' });
    }

    updateArrows () {
  if (!this.prevBtn || !this.nextBtn) return;

  const { scrollLeft, scrollWidth, clientWidth } = this.listEl;
  const atStart = scrollLeft <= 0;
  const atEnd   = scrollLeft + clientWidth >= scrollWidth - 1;

  this.prevBtn.disabled = atStart;
  this.nextBtn.disabled = atEnd;

  this.prevBtn.classList.toggle('disabled', atStart);
  this.nextBtn.classList.toggle('disabled', atEnd);
    }

    showEmpty (/* reason */) {
      this.emptyEl?.classList.remove('hidden');
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}